import type { LucideIcon } from "lucide-react";
import {
    ArrowLeftRight,
    BarChart3,
    Bookmark,
    Box,
    Boxes,
    Briefcase,
    Building2,
    Calendar,
    CheckSquare,
    Container,
    ExternalLink,
    FileText,
    GitBranch,
    Layers,
    LayoutGrid,
    Link2,
    Package,
    Plane,
    Radar,
    Route,
    Settings,
    Ship,
    Truck,
    User,
    Users,
    Wallet,
    Warehouse,
} from "lucide-react";

// Maps backend app/menu icon names to lucide icons. Falls back to the chain
// `Link2` glyph — generic "this is a link to something" — used when an icon
// name is unset or unmapped.
const ICON_MAP: Record<string, LucideIcon> = {
    "layout-grid": LayoutGrid,
    "link-2": Link2,
    "external-link": ExternalLink,
    bookmark: Bookmark,
    layers: Layers,
    "git-branch": GitBranch,
    users: Users,
    package: Package,
    settings: Settings,
    truck: Truck,
    ship: Ship,
    "file-text": FileText,
    "bar-chart": BarChart3,
    briefcase: Briefcase,
    "check-square": CheckSquare,
    box: Box,
    boxes: Boxes,
    // Logistics equipment module — the seed uses `icon="equipment"` on
    // the Equipment Control app entry (data/equipment_operations_menus.xml).
    // Cube glyph reads as "shipping container / unit of cargo equipment".
    equipment: Box,
    calendar: Calendar,
    wallet: Wallet,
    warehouse: Warehouse,
    // Summary meta-strip glyphs (form-view revamp — subtitle icon= tokens).
    "building-2": Building2,
    user: User,
    container: Container,
    route: Route,
    plane: Plane,
    "arrow-left-right": ArrowLeftRight,
    // Tracking & Visibility module — radar glyph reads as "cargo-in-motion
    // visibility surface" (data/tracking_menus.xml).
    radar: Radar,
};

export function appIcon(name?: string): LucideIcon {
    return (name && ICON_MAP[name]) || Link2;
}
